import axios from "axios";
import { decode } from "js-base64";
import { jwtDecode } from "jwt-decode";
export const getCookie=(name)=> {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
  
  export const isTokenValid= async (token)=>{
    try {
      deleteCookie('userGuid');
      const response = await axios.get(`${process.env.REACT_APP_IDENTITY_BASE_URL}api/v1/users/validateToken`, {
      headers: {
        Authorization: token,
      },
    });
    const decodeToken = jwtDecode(response?.data?.token);
      setCookie('userGuid',decodeToken?.userGuid)
      setCookie('firstName',decodeToken?.firstName);
      setCookie('lastName',decodeToken?.lastName)
      setCookie('email',decodeToken?.email)
      setCookie('role', decodeToken?.userRole)
      return response?.data?.token
    } catch (error) {
      return false;
    }
}

export const deleteCookie=(name)=> {
    document.cookie =  name + `=; Max-Age=0;secure;path=/`;
  }
  export const setCookie=(name, value)=> {
    document.cookie = `${name}=${value};path=/`;
  }

  export function getUserData(key) {
    try {
      const User = getCookie("User");
      if (User) {
      const userData = JSON.parse(User);
    
      return userData[key] ?? null;
      }
    } catch (error) {
      console.error("Error parsing User cookie:", error);
    }
    return null; // Return null if cookie is not found or an error occurs
    }